var _templateObject = _taggedTemplateLiteralLoose(['\n  div {\n    width: auto;\n  }\n'], ['\n  div {\n    width: auto;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import Button from '../../../StyledComponents/Button';
import theme from '../../../../themes/rml';
var Container = styled.div(_templateObject);

var LoginButton = function LoginButton(_ref) {
  var onClick = _ref.onClick;
  return React.createElement(Container, null, React.createElement(Button, {
    onClick: onClick,
    customSize: true,
    size: theme.header && theme.header.fontSize || 'normal'
  }, 'Login'));
};

export default withTheme(LoginButton);